import { selectUserProfile } from "store/selectors/selectUser";
import { formatPhoneNumber } from "utils/phoneNumber";
import { formatBirthDate, formatFullName, formatGender } from "utils/profile";

import { createSelector } from "@reduxjs/toolkit";

export const selectInsuranceProfileReviewInfo = createSelector(selectUserProfile, profile => {
  return {
    address: profile.activeAddress.formattedDisplay || "",
    birthDate: formatBirthDate(profile.birthdate),
    gender: formatGender(profile.gender),
    name: formatFullName({
      firstName: profile.firstName,
      middleName: profile.middleName,
      lastName: profile.lastName,
      suffix: profile.suffix,
    }),
    phoneNumber: formatPhoneNumber(profile.activePhoneNumber),
    ssn: profile.taxIdSet ? "***-**-****" : "",
  };
});
